














import { computed, defineComponent } from '@nuxtjs/composition-api'

import { useClassifiedForm } from '~/compositions/form'
import { formFieldProps } from '~/constants/form'
import { Option } from '~/models/shared/types'

export default defineComponent({
  props: formFieldProps,
  setup(props) {
    const { specs, name } = props
    const subUsersOptions = computed((): Option[] =>
      (specs?.values || []).map((v: any) => ({ text: v.name, value: v.value }))
    )
    const placeholder = computed(() => specs.value?.placeholder || '')

    const { value, error, valueChanged } = useClassifiedForm(props)

    const handleValueChange = (v: any) => {
      valueChanged(name, v)
    }

    return { subUsersOptions, value, error, handleValueChange, placeholder }
  }
})
